/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Cohort Analysis — retention grid + curve (ported), driven by live data.
 *  Real retention when server-side stitching is on; acquisition cohorts otherwise. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  function segScope(sg){var h=document.querySelector('[data-segtitle]');if(!h||!sg||!sg.name)return;var s=h.querySelector('.gs-seg-scope');if(!s){s=document.createElement('span');s.className='gs-seg-scope';s.style.cssText='color:#6B7280;font-weight:500;font-size:.6em;margin-left:7px;letter-spacing:normal;vertical-align:middle';h.appendChild(s);}s.textContent='\u00b7 '+sg.name;}
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.0, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["cohort-analysis"] = "1.0.2"; } catch (e) {}
  if (window.__cohortWired) return; window.__cohortWired = 1;

  var NS = "http://www.w3.org/2000/svg";
  function E(t) { return document.createElementNS(NS, t); }
  function A(e, a) { for (var k in a) e.setAttribute(k, a[k]); return e; }
  var root, tip;
  function q(s) { return root ? root.querySelector('[data-c="' + s + '"]') : null; }
  function qa(s) { return root ? Array.prototype.slice.call(root.querySelectorAll(s)) : []; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function ready(fn) { var done = false; function go() { if (done) return; done = true; fn(); } document.addEventListener("gs:ready", go, { once: true }); var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30); if (window.GS && GS.api && GS.site) go(); }
  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var DATA = null, MODE = "grid", GRAN = "week", currentId = 0;

  /* range (cohort-scoped; retention needs longer windows than the dashboard) */
  function _ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
  function _today() { var t = new Date(); return new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days) { var to = _today(), from = new Date(to.getTime() - (days - 1) * 86400000); var lbl = days === 84 ? T("an.last12wk") : days === 30 ? T("an.last30") : days === 180 ? T("an.last6mo") : T("an.last12mo"); return { from: _ymd(from), to: _ymd(to), label: lbl, preset: String(days) }; }
  var RANGE = (function () { try { var s = JSON.parse(localStorage.getItem("gs_cohort_range") || "null"); /* A stored preset is a RULE ("last 12 weeks"), not a fixed window — restoring its absolute
     dates freezes the report on whenever you last touched the picker, and Refresh then
     re-queries that dead window forever. Presets re-anchor; a custom range is kept. */
  if (s && s.preset) return preset(+s.preset);
  if (s && s.from && s.to) return s; } catch (e) {} return preset(84); })();
  function saveRange() { try { localStorage.setItem("gs_cohort_range", JSON.stringify(RANGE)); } catch (e) {} }

  /* color scale: light -> dark blue (from design) */
  function lerp(a, b, t) { return Math.round(a + (b - a) * t); }
  function hx(r, g, b) { return "#" + [r, g, b].map(function (x) { return ("0" + x.toString(16)).slice(-2); }).join(""); }
  function scaleColor(pct) {
    var t = Math.max(0, Math.min(1, pct / 100)), c0 = [234, 241, 253], c1 = [111, 157, 238], c2 = [26, 79, 176], r, g, b, k;
    if (t < 0.5) { k = t / 0.5; r = lerp(c0[0], c1[0], k); g = lerp(c0[1], c1[1], k); b = lerp(c0[2], c1[2], k); }
    else { k = (t - 0.5) / 0.5; r = lerp(c1[0], c2[0], k); g = lerp(c1[1], c2[1], k); b = lerp(c1[2], c2[2], k); }
    return { bg: hx(r, g, b), ink: t > 0.42 ? "#fff" : "#1A1D21" };
  }

  function showTip(html, x, y) { tip.innerHTML = html; tip.classList.add("show"); var w = tip.offsetWidth, h = tip.offsetHeight, px = x + 16, py = y + 16; if (px + w > innerWidth - 8) px = x - w - 16; if (py + h > innerHeight - 8) py = y - h - 16; tip.style.left = px + "px"; tip.style.top = py + "px"; }
  function hideTip() { tip.classList.remove("show"); }

  /* ---------- retention grid ---------- */
  function renderGrid() {
    var stage = q("stage"); stage.innerHTML = "";
    var cohorts = DATA.cohorts, P = DATA.periods, col = DATA.col_label || "Week";
    var scroll = document.createElement("div"); scroll.className = "grid-scroll";
    var grid = document.createElement("div"); grid.className = "rgrid";
    grid.style.gridTemplateColumns = "160px repeat(" + P + ",minmax(52px,1fr))";
    var corner = document.createElement("div"); corner.className = "corner"; grid.appendChild(corner);
    for (var p = 0; p < P; p++) { var ch = document.createElement("div"); ch.className = "colh"; ch.dataset.col = p; ch.textContent = col + " " + p; grid.appendChild(ch); }

    cohorts.forEach(function (c, ri) {
      var rh = document.createElement("div"); rh.className = "rowh"; rh.dataset.row = ri;
      rh.innerHTML = '<span>' + esc(c.label) + '</span><span class="sz num">' + (+c.size).toLocaleString() + ' visitors</span>';
      grid.appendChild(rh);
      for (var p2 = 0; p2 < P; p2++) {
        var cell = document.createElement("div");
        if (c.ret && p2 < c.ret.length) {
          var pct = c.ret[p2].pct, n = c.ret[p2].n, sc = scaleColor(pct);
          cell.className = "cell anim"; cell.style.background = sc.bg; cell.style.color = sc.ink;
          cell.dataset.row = ri; cell.dataset.col = p2; cell.textContent = pct + "%";
          cell.__tip = '<div class="tt">' + esc(c.label) + ' &middot; ' + col + ' ' + p2 + '</div><div class="big">' + pct + '%</div>' +
            '<div class="tr"><span>retained</span><b>' + (+n).toLocaleString() + '</b></div>' +
            '<div class="tr"><span>of cohort</span><b>' + (+c.size).toLocaleString() + '</b></div>' +
            (p2 > 0 ? '<div class="tr"><span>vs ' + col + ' ' + (p2 - 1) + '</span><b>' + (pct - c.ret[p2 - 1].pct) + ' pts</b></div>' : '');
        } else { cell.className = "cell empty"; }
        grid.appendChild(cell);
      }
    });
    scroll.appendChild(grid); stage.appendChild(scroll);
    var sb = document.createElement("div"); sb.className = "scalebar"; sb.innerHTML = 'Lower <span class="ramp"></span> Higher retention'; stage.appendChild(sb);

    function clearHot() { grid.classList.remove("focus"); grid.querySelectorAll(".hot,.col").forEach(function (n) { n.classList.remove("hot", "col"); }); }
    grid.addEventListener("mousemove", function (e) {
      var cell = e.target.closest && e.target.closest(".cell");
      if (!cell || cell.classList.contains("empty") || !cell.__tip) { clearHot(); hideTip(); return; }
      var ri = cell.dataset.row, ci = cell.dataset.col; clearHot(); grid.classList.add("focus"); cell.classList.add("hot");
      grid.querySelectorAll('.cell[data-col="' + ci + '"]').forEach(function (n) { if (n !== cell) n.classList.add("col", "hot"); });
      var rh2 = grid.querySelector('.rowh[data-row="' + ri + '"]'); if (rh2) rh2.classList.add("hot");
      var ch2 = grid.querySelector('.colh[data-col="' + ci + '"]'); if (ch2) ch2.classList.add("hot");
      showTip(cell.__tip, e.clientX, e.clientY);
    });
    grid.addEventListener("mouseleave", function () { clearHot(); hideTip(); });
    requestAnimationFrame(function () { requestAnimationFrame(function () { grid.querySelectorAll(".cell.anim").forEach(function (c, i) { c.style.transitionDelay = (RM ? 0 : i * 9) + "ms"; }); grid.classList.add("in"); }); });
  }

  /* ---------- retention curve ---------- */
  function renderCurve() {
    var stage = q("stage"); stage.innerHTML = "";
    var cohorts = DATA.cohorts, P = DATA.periods, col = DATA.col_label || "Week";
    var W = 900, H = 340, mL = 44, mR = 16, mT = 16, mB = 34, iw = W - mL - mR, ih = H - mT - mB;
    var x = function (k) { return mL + (P <= 1 ? 0 : k / (P - 1) * iw); };
    var y = function (v) { return mT + (1 - v / 100) * ih; };
    var svg = A(E("svg"), { viewBox: "0 0 " + W + " " + H, class: "c-curve", preserveAspectRatio: "xMidYMid meet" });
    [0, 25, 50, 75, 100].forEach(function (v) {
      svg.appendChild(A(E("line"), { x1: mL, y1: y(v), x2: W - mR, y2: y(v), stroke: "#EEF1F6" }));
      var t = A(E("text"), { x: mL - 8, y: y(v) + 3, "text-anchor": "end", "font-size": "10", fill: "#9AA1AC" }); t.textContent = v + "%"; svg.appendChild(t);
    });
    for (var k = 0; k < P; k++) { var tx = A(E("text"), { x: x(k), y: H - 12, "text-anchor": "middle", "font-size": "10", fill: "#9AA1AC" }); tx.textContent = col[0] + k; svg.appendChild(tx); }
    cohorts.forEach(function (c, i) {
      var t = cohorts.length <= 1 ? 1 : i / (cohorts.length - 1), sc = scaleColor(40 + t * 55);
      var pts = c.ret.map(function (r, k2) { return x(k2) + "," + y(r.pct); }).join(" ");
      svg.appendChild(A(E("polyline"), { points: pts, fill: "none", stroke: sc.bg, "stroke-width": i === cohorts.length - 1 ? 3 : 1.6, "stroke-linejoin": "round", "stroke-linecap": "round", opacity: i === cohorts.length - 1 ? 1 : 0.75 }));
      c.ret.forEach(function (r, k3) { var dot = A(E("circle"), { cx: x(k3), cy: y(r.pct), r: 3, fill: sc.bg }); dot.__tip = '<div class="tt">' + esc(c.label) + ' &middot; ' + col + ' ' + k3 + '</div><div class="big">' + r.pct + '%</div><div class="tr"><span>retained</span><b>' + (+r.n).toLocaleString() + '</b></div>'; svg.appendChild(dot); });
    });
    svg.addEventListener("mousemove", function (e) { var t = e.target; if (t && t.__tip) showTip(t.__tip, e.clientX, e.clientY); else hideTip(); });
    svg.addEventListener("mouseleave", hideTip);
    stage.appendChild(svg);
    var leg = document.createElement("div"); leg.className = "c-legend";
    leg.innerHTML = cohorts.slice(-6).map(function (c, i, a) { var t = a.length <= 1 ? 1 : i / (a.length - 1); return '<span><i style="background:' + scaleColor(40 + t * 55).bg + '"></i>' + esc(c.label) + '</span>'; }).join("");
    stage.appendChild(leg);
  }

  /* ---------- acquisition fallback table ---------- */
  function renderAcquisition() {
    var stage = q("stage"); var rows = DATA.cohorts || [];
    var head = '<thead><tr><th class="l">'+TR('cohort.g.cohort')+'</th><th>'+TR('cohort.g.visitors')+'</th><th>'+TR('cohort.g.sessions')+'</th><th>'+TR('cohort.pages_visit')+'</th><th>'+TR('cohort.g.avg_time')+'</th><th>'+TR('cohort.conv')+'</th></tr></thead>';
    function cohRow(c) {
      var mm = Math.floor(c.avg_seconds / 60), ss = c.avg_seconds % 60;
      return '<tr><td class="l">' + esc(c.label) + '</td><td class="num">' + (+c.size).toLocaleString() + '</td><td class="num">' + (+c.sessions).toLocaleString() +
        '</td><td class="num">' + c.pages_per_visit + '</td><td class="num">' + (mm ? mm + "m " : "") + ss + 's</td><td class="num">' + c.conv_pct + '%</td></tr>';
    }
    // Header is built here, so the shell goes in first and the pager mounts on its tbody.
    stage.innerHTML = '<table class="acq">' + head + '<tbody></tbody></table>';
    var ctb = stage.querySelector('tbody');
    if (window.GSMore) GSMore.mount({ container: ctb, table: true, colspan: 6, items: rows, pageSize: 20, emptyText: TR('cohort.f2.no_cohorts_in_this_range'), render: cohRow });
    else ctb.innerHTML = rows.map(cohRow).join("");
  }

  function render() {
    if (!DATA || !DATA.cohorts || !DATA.cohorts.length) { q("stage").innerHTML = ""; q("empty").hidden = false; q("empty").textContent = TT('ca.a.no_cohort_data_in_this_range_yet'); return; }
    q("empty").hidden = true;
    if (DATA.mode === "acquisition") { renderAcquisition(); return; }
    if (MODE === "curve") renderCurve(); else renderGrid();
  }

  function fmtKpi(el, v, suffix) { if (!el) return; el.innerHTML = v + (suffix || ""); }
  function renderKpis() {
    var k = DATA.kpis || {}, col = DATA.col_label || "Week";
    if (DATA.mode === "retention") {
      q("k1lbl").textContent = col + " 1 retention"; q("k4lbl").textContent = col + " 4 retention";
      fmtKpi(q("k1"), (k.p1 != null ? k.p1 : 0), '<small>%</small>');
      fmtKpi(q("k4"), (k.p4 != null ? k.p4 : 0), '<small>%</small>');
      q("ksz").textContent = (k.avg_size || 0).toLocaleString();
      q("kret").textContent = (k.returning || 0).toLocaleString();
    } else {
      q("k1lbl").textContent = TT('ca.a.cohorts'); q("k4lbl").textContent = TT('ca.a.total_visitors');
      q("k1").textContent = (k.periods || 0).toLocaleString(); q("k4").textContent = (k.total || 0).toLocaleString();
      q("ksz").textContent = (k.avg_size || 0).toLocaleString(); q("kret").textContent = "\u2014";
    }
  }

  /**
   * The banner used to explain visitor stitching and offer to turn it on or off.
   *
   * Stitching is always on here, so all three states were noise: "Retention is live from
   * cookie-free server-side stitching" told you about a setting you cannot change, and
   * "Turn stitching off" / "Enable stitching" offered a switch that should not be flipped from a
   * report. The one state worth keeping is the honest empty one — retention genuinely has nothing
   * to show until visitors come back, and that is a fact about your data, not a setting.
   */
  function renderBanner() {
    var b = q("banner"); if (!b) return;
    if (DATA.mode !== "retention" && DATA.stitch) {
      b.className = "c-banner info"; b.hidden = false;
      b.innerHTML = '<div><i class="bi bi-hourglass-split me-1"></i>Retention will fill in here as visitors return over the coming ' +
        (DATA.col_label || "week").toLowerCase() + 's. Showing acquisition cohorts meanwhile.</div>';
      return;
    }
    b.hidden = true; b.innerHTML = "";
  }


  /* ---------- data ---------- */
  function load(id) {
    currentId = id || 0;
    GS.api("/plugin/cohort-analysis/get?" + siteParam() + (currentId ? "&id=" + currentId : "") + "&from=" + RANGE.from + "&to=" + RANGE.to + "&gran=" + GRAN).then(function (r) {
      if (!r.ok || !r.data || r.data.error) { q("empty").hidden = false; q("empty").textContent = TT('ca.a.no_cohort_view_available_yet'); return; }
      DATA = r.data; currentId = DATA.view ? DATA.view.id : currentId;
      if (DATA.view) { GRAN = DATA.view.granularity; q("granLabel").textContent = GRAN.charAt(0).toUpperCase() + GRAN.slice(1); qa('[data-c="granMenu"] .mi').forEach(function (x) { x.classList.toggle("sel", x.getAttribute("data-gran") === GRAN); }); }
      q("title").textContent = (DATA.view && DATA.view.name) || "Retention";
      segScope(DATA.scoped_segment);
      renderBanner(); renderKpis(); render();
    });
  }
  function loadList() {
    GS.api("/plugin/cohort-analysis/list?" + siteParam()).then(function (r) {
      var vs = (r.ok && r.data && r.data.views) || [], pick = q("picker");
      if (pick) pick.innerHTML = vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.name) + '</option>'; }).join("") || '<option>'+TT('ca.js.no_views')+'</option>';
      load(vs.length ? +vs[0].id : 0);
    });
  }

  function menuToggle(btnKey, menuKey, onPick) {
    var btn = q(btnKey), menu = q(menuKey); if (!btn || !menu) return;
    btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); menu.classList.toggle("open"); });
    document.addEventListener("click", function () { menu.classList.remove("open"); });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    menu.querySelectorAll(".mi").forEach(function (mi) { mi.addEventListener("click", function () { menu.classList.remove("open"); onPick(mi); }); });
  }

  function initRange() {
    var btn = q("rangeBtn"), menu = q("rangeMenu"), lab = q("range-label"); if (!btn || !menu) return;
    if (lab && RANGE.label) lab.textContent = RANGE.label;
    function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === RANGE.preset); }); }
    sync();
    btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); var open = menu.style.display !== "none"; menu.style.display = open ? "none" : "block"; if (!open) { var cf = menu.querySelector('[data-rp="from"]'), ct = menu.querySelector('[data-rp="to"]'); if (cf) cf.value = RANGE.from; if (ct) ct.value = RANGE.to; sync(); } });
    document.addEventListener("click", function () { menu.style.display = "none"; });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    function apply(r) { RANGE = r; if (lab) lab.textContent = RANGE.label; saveRange(); menu.style.display = "none"; load(currentId); }
    menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { apply(preset(+b.getAttribute("data-preset"))); sync(); }); });
    var ap = menu.querySelector('[data-rp="apply"]'); if (ap) ap.addEventListener("click", function () { var f = menu.querySelector('[data-rp="from"]').value, t = menu.querySelector('[data-rp="to"]').value; if (!f || !t) return; if (f > t) { var x = f; f = t; t = x; } apply({ from: f, to: t, label: f + " \u2192 " + t, preset: null }); });
  }

  function init() {
    root = document.querySelector('[data-c="root"]'); if (!root) return;
    tip = q("tip");
    menuToggle("granBtn", "granMenu", function (mi) { GRAN = mi.getAttribute("data-gran"); q("granLabel").textContent = mi.textContent.trim(); qa('[data-c="granMenu"] .mi').forEach(function (x) { x.classList.remove("sel"); }); mi.classList.add("sel"); load(currentId); });
    menuToggle("vizPill", "vizMenu", function (mi) { MODE = mi.getAttribute("data-viz"); q("vizLabel").textContent = mi.textContent.trim(); qa('[data-c="vizMenu"] .mi').forEach(function (x) { x.classList.remove("sel"); }); mi.classList.add("sel"); render(); });
    var pick = q("picker"); if (pick) pick.addEventListener("change", function () { load(+pick.value); });
    var refresh = q("refresh"); if (refresh) refresh.addEventListener("click", function () { load(currentId); });
    initRange();
    loadList();
  }
  ready(init);
})();
